import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Keys, StorageService } from '../../service/storage.service';
import { PaymentCollectionService } from '../../service/payment-collection.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CardDetail, PaymentCollectionRequest, SavedCardDetail } from '../../model/payment/PaymentCollectionRequest';
import { ConfigService } from '../../service/config.service';


@Component({
    selector: 'app-payment-mode-saved-payment',
    templateUrl: './payment-mode-saved-payment.component.html',
    styleUrls: ['./../../../assets/styles/finzy-styles.scss', './payment-mode-saved-payment.component.scss']
})
export class PaymentModeSavedPaymentComponent implements OnInit {
    public savedPaymentItems: CardDetail[];
    public showViewAllButton: boolean = false;
    public savedPaymentItemForm: FormGroup;
    public savedCardList: CardDetail[];
    public selectedPaymentDetail: CardDetail;
    public payUConvenienceFeeGSTPercentage: number;

    @Output()
    isFormInstanceCreated: EventEmitter<any> = new EventEmitter<any>();
    @Input()
    paymentRequest: PaymentCollectionRequest;

    constructor(private paymentCollectionService: PaymentCollectionService, private storageService: StorageService,
        private formBuilder: FormBuilder, private configService: ConfigService) {
    }

    async ngOnInit(): Promise<void> {
        this.paymentRequest.paymentDetails = {}
        this.getpayUConvenienceFee();
        await this.initializeForm();
        try {
            const savedCards: SavedCardDetail = await this.paymentCollectionService.getSavedCardDetail(this.storageService.getItem(Keys.PROFILE_ID));
            this.savedCardList = Object.values(savedCards.user_cards);
            this.paymentListToDisplay(this.savedCardList);
        } catch (e) {
        }
    }

    async initializeForm() {
        this.savedPaymentItemForm = this.formBuilder.group({
            cardCVV: this.formBuilder.control(null, [Validators.required, Validators.minLength(3), Validators.pattern("^[0-9]*")]),
            cardToken: this.formBuilder.control(null, [Validators.required])
        });
        this.isFormInstanceCreated.emit(this.savedPaymentItemForm);
    }
    get savedPaymentItemControles() {
        return this.savedPaymentItemForm.controls;
    }

    public paymentListToDisplay(responseArray) {
        if (responseArray.length > 3) {
            this.savedPaymentItems = responseArray.slice(0, 3);
            this.showViewAllButton = true;
        } else {
            this.savedPaymentItems = responseArray;
        }
    }

    public showFullSavedPaymentList() {
        this.showViewAllButton = false;
        this.savedPaymentItems = this.savedCardList;
    }

    public onSavedPaymentSelect() {
        this.paymentRequest.paymentDetails.cardDetails.cardCVV = null;
        this.paymentRequest.paymentDetails.cardDetails['cardHolderName'] = this.selectedPaymentDetail?.card_name;
        this.paymentRequest.paymentDetails.cardDetails['cardNumber'] = this.selectedPaymentDetail?.card_no;
        this.paymentRequest.paymentDetails.cardDetails['cardExpiryMonth'] = this.selectedPaymentDetail?.expiry_month;
        this.paymentRequest.paymentDetails.cardDetails['cardExpiryYear'] = this.selectedPaymentDetail?.expiry_year;
        this.paymentRequest.paymentDetails.cardDetails['storedCardToken'] = this.selectedPaymentDetail?.card_token;
        this.paymentRequest.paymentDetails.cardDetails['cardType'] = this.selectedPaymentDetail?.card_brand;
        delete this.paymentRequest.paymentDetails.cardDetails['rememberCard'];
    }
    public getpayUConvenienceFee() {
        const payUConvenienceFeeOfDebitCard =  this.configService.getPayUConvenienceFeeOfDebitCard();
        this.payUConvenienceFeeGSTPercentage =  this.configService.getPayUConvenienceFeeGSTPercentage();
        return payUConvenienceFeeOfDebitCard * (1 + this.payUConvenienceFeeGSTPercentage / 100);
    }
}
